<template>
  <div>

<!--    <b-card>-->
<!--      &lt;!&ndash; FILTER START &ndash;&gt;-->
<!--      <b-row>-->
<!--        <b-col md="3">-->
<!--          <b-form-group label="Date from" label-for="datefrom" rules="required">-->
<!--            <template #label>{{ $t("labels.datefrom") }}</template>-->
<!--            <flat-pickr v-model="filterSelect.dateFrom" @input="inputSelect" class="form-control" :config="{-->
<!--              altInput: true,-->
<!--              altFormat: 'd-m-Y H:i K',-->
<!--              enableTime: true,-->
<!--              dateFormat: 'Y-m-d 00:00:00',-->
<!--              time_24hr: true,-->
<!--            }" />-->
<!--          </b-form-group>-->
<!--        </b-col>-->
<!--        <b-col md="3">-->
<!--          <b-form-group label="Date To" label-for="dateto" rules="required">-->
<!--            <template #label>{{ $t("labels.dateto") }}</template>-->
<!--            <flat-pickr v-model="filterSelect.dateAt" @input="inputSelect" class="form-control" :config="{-->
<!--              altInput: true,-->
<!--              altFormat: 'd-m-Y H:i K',-->
<!--              enableTime: true,-->
<!--              dateFormat: 'Y-m-d 23:59:59',-->
<!--              time_24hr: true,-->
<!--            }" />-->
<!--          </b-form-group>-->
<!--        </b-col>-->

<!--        <b-col md="3">-->
<!--          <b-form-group label="typeUser" label-for="typeUser">-->
<!--                <template #label>Role</template>-->
<!--                <v-select-->
<!--                  @input="inputSelect"-->
<!--                  v-model="filterSelect.typeUser"-->
<!--                  :options="typeUsersOptios"-->
<!--                  :filterable="false"-->
<!--                  :clearable="true"-->
<!--                  label="typeUser"-->
<!--                >-->
<!--                </v-select>-->
<!--              </b-form-group>-->
<!--        </b-col>-->

<!--        <b-col md="3">-->
<!--          <b-form-group label="userName" label-for="username">-->
<!--                <template #label>{{ $t("labels.user")}}</template>-->
<!--                <v-select-->
<!--                  @option:selected="selectPlayer"-->
<!--                  :options="userList"-->
<!--                  @search="onSearch"-->
<!--                  :filterable="false"-->
<!--                  :clearable="false"-->
<!--                  label="userName"-->
<!--                >-->
<!--                  <template slot="no-options">-->
<!--                    {{ $t("type_a_letter_to_start_the_search") }}-->
<!--                  </template>-->
<!--                  <template slot="option" slot-scope="option">-->
<!--                    <div class="d-center">-->
<!--                      {{ option.userName }}-->
<!--                    </div>-->
<!--                  </template>-->
<!--                </v-select>-->
<!--              </b-form-group>-->
<!--        </b-col>-->

<!--      </b-row>-->
<!--      &lt;!&ndash; FILTER END &ndash;&gt;-->
<!--    </b-card>-->

    <b-card :title="$t('labels.audit')">
      <b-overlay :show="loadingData" variant="transparent" no-wrap />
      <b-modal id="modalResponse" title="PopUp Response" cancel-variant="outline-secondary" scrollable>
        <b-card-text>
          {{ rows }}
        </b-card-text>
      </b-modal>

      <!-- table -->
      <div class="table-responsive pb-3">
        <vue-good-table mode="remote"
                        :columns="defineColumns()"
                        :rows="rows"
                        :totalRows="totalRows"
                        :pagination-options="{ enabled: true }"
                        :sort-options="{ enabled: false }"
                        class="table">

          <template slot="table-row" slot-scope="props">

            <div v-if="props.column.field == 'body'">

              <!-- show modal v-b-modal -->
              <div class="d-flex align-items-center justify-content-center">

                <b-button
                        style="margin-bottom: 3px"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        v-b-modal="'modalBody'+props.row._id"
                        size="sm"
                        variant="outline-success"
                >
                  Body
                </b-button>

<!--                <b-button-->
<!--                        class="mb-1"-->
<!--                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"-->
<!--                        v-b-modal="'modalHeaders'+props.row._id"-->
<!--                        size="sm"-->
<!--                        variant="outline-dark"-->
<!--                >-->
<!--                  Headers-->
<!--                </b-button>-->

<!--                <b-button-->
<!--                        class="mb-1"-->
<!--                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"-->
<!--                        v-b-modal="'modalRequest'+props.row._id"-->
<!--                        size="sm"-->
<!--                        variant="outline-danger"-->
<!--                >-->
<!--                  Request-->
<!--                </b-button>-->

<!--                <b-button-->
<!--                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"-->
<!--                        v-b-modal="'modalResponse'+props.row._id"-->
<!--                        size="sm"-->
<!--                        variant="outline-success"-->
<!--                >-->
<!--                  Response-->
<!--                </b-button>-->

              </div>

              <!-- Body (data)  -->
              <b-modal
                      size="xl"
                      :id="'modalBody'+props.row._id"
                      title="Body"
                      cancel-variant="outline-secondary"
                      scrollable
              >
                <prism language="javascript">
                  {{props.row.data}}
                </prism>
              </b-modal>

              <!-- Request -->
              <b-modal
                      size="xl"
                      :id="'modalHeaders'+props.row._id"
                      title="Headers"
                      cancel-variant="outline-secondary"
                      scrollable
              >
                <prism language="javascript">
                  {{props.row.headers}}
                </prism>
              </b-modal>

              <!-- Route -->
              <b-modal
                      size="xl"
                      :id="'modalRequest'+props.row._id"
                      title="Request"
                      cancel-variant="outline-secondary"
                      scrollable
              >
                <prism language="javascript">
                  {{props.row.request}}
                </prism>
              </b-modal>

              <b-modal
                      size="xl"
                      :id="'modalResponse'+props.row._id"
                      title="Response"
                      cancel-variant="outline-secondary"
                      scrollable
              >
                <prism language="javascript">
                  {{props.row.response}}
                </prism>
              </b-modal>

            </div>

          </template>

          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <!-- page length -->
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Showing 1 to </span>
                <b-form-select v-model="serverParams.perPage" :options="pages" class="mx-1" @input="onPerPageChange" />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
              </div>

              <!-- pagination -->
              <div>
                <b-pagination :value="1" :total-rows="props.total" :per-page="serverParams.perPage" first-number
                              last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                              @change="onPageChange">
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </div>

    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BOverlay,
  BPagination,
  BFormSelect,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BInputGroup,
  BCollapse,
  VBToggle,
  VBModal,
  BCardText,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { formatDateTimeHumane } from '@core/utils/filter'
import moment from "moment";
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import Prism from 'vue-prism-component'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BOverlay,
    BPagination,
    BFormSelect,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BInputGroup,
    BCollapse,
    VBModal,
    BCardText,
    VBToggle,
    vSelect,
    VueGoodTable,
    flatPickr,
    Prism,
    ToastificationContent,
  },

  directives: {
    "b-toggle": VBToggle,
    "b-modal": VBModal,
    Ripple,
  },

  data() {
    return {
      dates: "",
      loadingData: false,
      pages: [20, 40, 60],
      typeUsersOptios: [
        'Admin',
        'Agent',
        'Player',
      ],
      timeout: null,
      rows: [],
      serverParams: {
        page: 1,
        perPage: 20,
      },
      totalRows: 0,
      customerOptions: [],
      productsOptions: [],
      currencyssOptions: [],
      platformOptions: [
        { label: "Web", value: "web" },
        { label: "Admin", value: "admin" },
        { label: "Gateway", value: "gateway" },
      ],
      filterSelect: {
        dateFrom: moment().subtract(1, "month").format("YYYY-MM-DD 00:00:00"),
        dateAt: moment().format("YYYY-MM-DD 23:59:59"),
        platform: "",
        id: "",
      },
      userList: [],
    };
  },

  methods: {

    defineColumns(){
      const columns = [
        { label: this.$t("tableHeader.user"), field: "userId.userName" },
        { label: this.$t("tableHeader.action"), field: "action" },
        // { label: this.$t("ip"), field: "headers.cf-connecting-ip" },
        // { label: this.$t("country"), field: "headers.cf-ipcountry" },
        // { label: this.$t("session_id"), field: "sessionId" },
        { label: this.$t("tableHeader.data"), field: "body" },
        // { label: this.$t("method"), field: "method" },
        // { label: this.$t("route"), field: "route" },
        // { label: this.$t("params"), field: "params" },
        { label: this.$t("tableHeader.date"), field: "createdAt",formatFn: this.formatCreatedAt},
      ]

      return columns
    },

    formatCreatedAt: function(value) {
      return moment(String(value)).format('DD-MM-YYYY HH:MM')
    },

    async getAudit() {
      try {
        if(this.filterSelect.platform == null){
          this.filterSelect.platform = ""
        }

        if(this.filterSelect.typeUser == null){
          delete this.filterSelect.typeUser
        }
        if(this.filterSelect.id == null || this.filterSelect.id == ""){
          delete this.filterSelect.id
        }
        const payload = {
          ...this.filterSelect,
          "paginate": {
            ...this.serverParams,
            "sortDesc": true
          }
        }
        this.loadingData = true;
        const res = await this.$store.dispatch("moduleAudit/index", payload);
        this.rows = res.data.audits;
        this.totalRows = res.data.total;
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching list",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.loadingData = false;
      }
    },

    onPageChange(page) {
      this.serverParams.page = page;
      this.getAudit();
    },

    onPerPageChange(perPage) {
      this.serverParams.page = 1
      this.serverParams.perPage = perPage;
      this.getAudit();
    },

    inputSelect(val) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getAudit();
      }, 800);
    },

    selectPlayer({ _id }) {
      this.filterSelect.id = _id;
      this.getAudit();
    },

    async getCustomer() {
      const res = await this.$store.dispatch("reports/getCustomer");
      this.customerOptions = res.data;
    },

    async getProducts() {
      const res = await this.$store.dispatch("reports/getProducts");
      this.productsOptions = res.data;
    },

    async getCurrencys() {
      const res = await this.$store.dispatch("reports/getCurrencys");
      this.currencyssOptions = res.data.currencys;
    },

    search(loading, search, vm) {
      loading(true);
      //console.log(this.userName.trim());.
      this.$store.dispatch("user/fetchUsersByName", search).then((response) => {
        this.userList = response.data;
        loading(false);
      });
    },

    onSearch(search, loading) {
      if (search.length) {
        loading(true);

        if (this.timeOut) clearTimeout(this.timeOut);

        this.timeOut = setTimeout(() => {
          this.search(loading, search, this);
        }, 500);
      }
    },

  },
  created() {
    this.getAudit();
  },
};
</script>

<style lang="scss" >
.per-page-selector {
  width: 90px;
}

@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

